import { SET_USER_ROLE_DATA } from "../../actions/actionTypes/userRole";

const initialState = {
  isResident: true,
  redirectUrl: "",
};

export function userRole(state = initialState, action: any) {
  switch (action.type) {
    case SET_USER_ROLE_DATA: {
      const { isResident, redirectUrl } = action.payload;
      return {
        ...state,
        isResident,
        redirectUrl,
      };
    }
    default:
      return state;
  }
}
